import { render, staticRenderFns, recyclableRender, components } from "./PreviewPag.vue?vue&type=template&id=82f19406&scoped=true&"
var renderjs
import script from "./PreviewPag.vue?vue&type=script&lang=js&"
export * from "./PreviewPag.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPag.vue?vue&type=style&index=0&id=82f19406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f19406",
  null,
  false,
  components,
  renderjs
)

export default component.exports